export default __webpack_public_path__ + "static/5-56ea4b1c9c35f174a96e4fb251f68802.webp";